module.exports = __webpack_public_path__ + "static/media/sbom-slide-9.2603f1f7.jpg";